import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MapListQuery } from 'src/app/store/map-list/state/map-list.query';
import { MapListState, MapListStore } from 'src/app/store/map-list/state/map-list.store';
import { SubSink } from 'subsink';

type MapListCheckBox = Record<keyof MapListState, FormControl>;

@Component({
  selector: 'app-map-list',
  templateUrl: './map-list.component.html',
  styleUrls: ['./map-list.component.scss'],
})
export class MapListComponent implements OnInit, OnDestroy {
  constructor(private store: MapListStore, private query: MapListQuery) {}
  selectedOptions: MapListState;
  formControls: MapListCheckBox = {
    mapType: new FormControl(true),
    showAirspace: new FormControl(null),
  };

  mapListFormGroup = new FormGroup(this.formControls);
  subs = new SubSink();
  ngOnInit(): void {
    this.mapListFormGroup.patchValue(this.store.getValue(), { emitEvent: false });
    this.subs.sink = this.mapListFormGroup.valueChanges.subscribe((x) => this.store.update(x));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
